import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
`;

export const Header = styled.div`
  text-align: center;

  h1 {
    font-family: 'Anton', sans-serif;
    margin-bottom: 20px;
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 3rem;
  margin-bottom: 3rem;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const VerticalDivider = styled.div`
  width: 2px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1px;

  @media (max-width: 968px) {
    display: none;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FilterLabel = styled.label`
  color: white;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 4px;
`;

export const FilterDivider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 28px 0px;
`;

export const ChoicesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const ChoiceButton = styled.button`
  padding: 0.75rem 1.75rem;
  background: ${({ $isActive }) =>
    $isActive ? 'linear-gradient(135deg, #d84315 0%, #bf360c 100%)' : 'white'};
  color: ${({ $isActive }) => ($isActive ? 'white' : '#333')};
  border: none;
  border-radius: 50px;
  font-size: 0.95rem;
  font-weight: ${({ $isActive }) => ($isActive ? '600' : '400')};
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    background: ${({ $isActive }) =>
      $isActive
        ? 'linear-gradient(135deg, #d84315 0%, #bf360c 100%)'
        : '#f5f5f5'};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ValueInputGroup = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ValueInputWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ValueLabel = styled.span`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.875rem;
`;

export const ValueInput = styled.input`
  padding: 0.75rem 1.25rem;
  background: white;
  color: #333;
  border: none;
  border-radius: 50px;
  font-size: 0.95rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
  }

  &::placeholder {
    color: #999;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  max-width: 400px;
  margin: 2rem auto 0;
  padding: 1.25rem 3rem;
  background: linear-gradient(135deg, #d84315 0%, #bf360c 100%);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 1.25rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 2px;
  box-shadow: 0 4px 20px rgba(216, 67, 21, 0.4);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 30px rgba(216, 67, 21, 0.6);
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const Empty = styled.div`
  padding: 3rem;
  text-align: center;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border: 1px dashed rgba(255, 255, 255, 0.2);

  h2 {
    color: rgba(255, 255, 255, 0.6);
    font-size: 1.5rem;
  }
`;

// Estilos antigos mantidos para compatibilidade
export const GroupInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  p {
    color: white;
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.5px;
  }
`;

export const Group = styled.div`
  width: 100%;
  display: flex;
  position: relative;
`;

export const Bubble = styled.label`
  width: 100%;
  display: flex;
  margin: 2px 0;
  padding: 12px 20px;
  background: ${({ $checked }) =>
    $checked ? 'linear-gradient(135deg, #d84315 0%, #bf360c 100%)' : 'white'};
  color: ${({ $checked }) => ($checked ? 'white' : '#333')};
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: ${({ $checked }) => ($checked ? '600' : '400')};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
`;

export const ButtonRemove = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s ease;

  &::before {
    content: '×';
  }

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-50%) scale(1.1);
  }
`;

export const Collumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
